var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ib-chevron-right_svg__filter0_d_1527_114751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4l17.638 5.941A2 2 0 0119 11.837v15.582a2 2 0 01-1.291 1.87L0 36V4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-chevron-right_svg__clip0_1527_114751)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.279 13.612a.952.952 0 011.347 0l5.714 5.714a.952.952 0 010 1.347l-5.714 5.715a.952.952 0 11-1.347-1.347L9.319 20l-5.04-5.04a.952.952 0 010-1.348z",
    fill: "#AAA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-chevron-right_svg__clip0_1527_114751"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.333 13.333)",
    d: "M0 0h13.333v13.333H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-chevron-right_svg__filter0_d_1527_114751",
    x: -2,
    y: 0,
    width: 27,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1527_114751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1527_114751",
    result: "shape"
  })))));
}

export default SvgIbChevronRight;